import React, { useEffect, useState } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronLeft,
  faChevronRight,
  faEye,
  faPencil,
  faPlus,
  faTrash,
} from '@fortawesome/free-solid-svg-icons'
import {
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap'
import { useDispatch } from 'react-redux'
import { getScheduledInterviews } from 'store/Recruitment/actions'
import { useSelector } from 'react-redux'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { formatToAmPm } from '../../../../utils/helpers'
import { getSystemSetup } from 'store/Recruitment/actions'
import { updateJobApplication } from 'store/Recruitment/actions'
import CreateInterviewModal from '../JobDetails/ApplicationDetails/CreateInterviewModal'
import { setFormSubmitted } from 'store/Recruitment/actions'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import { deleteInterview } from 'store/Recruitment/actions'
import AddToJobOnboard from '../JobDetails/ApplicationDetails/AddToJobOnboard'
import AxiosInstance from 'utils/AxiosInstance'

import './style.css'

const localizer = momentLocalizer(moment)

const InterviewSchedule = () => {
  const dispatch = useDispatch()
  const [events, setEvents] = useState([])

  const { interviews } = useSelector((store) => store.recruitment)

  const [showModal, setShowModal] = useState(false)
  const [showEditInterviewModal, setShowEditInterviewModal] = useState(false)
  const [showJobOnboardingModal, setShowJobOnboardingModal] = useState(false)
  const [showCreateInterviewModal, setShowCreateInterviewModal] =
    useState(false)

  const [event, setEvent] = useState(null)

  const handleEventClick = (event) => {
    setShowModal(true)
    setEvent(event)
  }

  useEffect(() => {
    dispatch(getSystemSetup(null, 'job_stage'))
  }, [dispatch, showModal])

  useEffect(() => {
    dispatch(getScheduledInterviews())
  }, [dispatch])

  useEffect(() => {
    const events = interviews?.map((interview) => {
      const startString = `${interview?.date?.split('T')?.[0]}T${
        interview?.time
      }:00`
      const endString = `${interview?.date?.split('T')?.[0]}T${
        interview?.end_time
      }:00`
      const start = new Date(startString)
      const end = new Date(endString)

      return {
        ...interview,
        title: interview.title,
        start,
        end,
      }
    })

    setEvents(events)
  }, [interviews])

  useEffect(() => {
    if (!showEditInterviewModal && !showCreateInterviewModal) {
      dispatch(setFormSubmitted(false))
    }
  }, [dispatch, showEditInterviewModal, showCreateInterviewModal])

  return (
    <>
      <Card
        onClick={() => setShowCreateInterviewModal(true)}
        className='bg-info text-white plus-button'
      >
        <FontAwesomeIcon icon={faPlus} className='' />
      </Card>
      <div
        className='d-flex align-items-start justify-content-between calendar-schedule-container'
        style={{ gap: '1rem' }}
      >
        <Card className='calendar-card'>
          <CardHeader className='title'>Calendar</CardHeader>
          <CardBody>
            <Calendar
              onSelectEvent={handleEventClick}
              localizer={localizer}
              events={events}
              startAccessor='start'
              endAccessor='end'
              defaultView='month'
              views={['month', 'week', 'day']}
              style={{ height: 500 }}
              messages={{
                today: 'Today',
                previous: <FontAwesomeIcon icon={faChevronLeft} />,
                next: <FontAwesomeIcon icon={faChevronRight} />,
                month: 'Month',
                week: 'Week',
                day: 'Day',
              }}
            />
          </CardBody>
        </Card>
        <Card className='schedule-list-card'>
          <CardHeader className='title'>Schedule List</CardHeader>
          <CardBody>
            {events
              ?.filter((event) =>
                moment(event.date).isSameOrAfter(moment(), 'day')
              )
              .map((event) => (
                <Card key={event.id} className=''>
                  <CardBody className='d-flex align-items-start'>
                    <div className='d-flex flex-column w-75'>
                      <span className='title font-weight-bold text-warning mb-3'>
                        {event?.title}
                      </span>
                      <span>{event?.applicant_name}</span>
                      <span>{moment(event?.date).format('DD-MM-YYYY')} </span>
                      <span>{formatToAmPm(event?.time)}</span>
                    </div>
                    <div className='d-flex align-items-center'>
                      <FontAwesomeIcon
                        role='button'
                        title='View'
                        icon={faEye}
                        className='text-warning'
                        size='xl'
                        onClick={() => {
                          setShowModal(true)
                          setEvent(event)
                        }}
                      />
                      <FontAwesomeIcon
                        role='button'
                        title='Edit'
                        icon={faPencil}
                        className='text-info ml-3'
                        size='xl'
                        onClick={() => {
                          setShowEditInterviewModal(true)
                          setEvent(event)
                        }}
                      />
                      <FontAwesomeIcon
                        role='button'
                        title='Delete'
                        icon={faTrash}
                        className='text-danger ml-3'
                        size='xl'
                        onClick={() => {
                          dispatch(
                            setAreYouSureModalData({
                              show: true,
                              customFn: () =>
                                dispatch(deleteInterview(event?.id)),
                            })
                          )
                        }}
                      />
                    </div>
                  </CardBody>
                </Card>
              ))}
          </CardBody>
        </Card>
        {showModal && (
          <InterviewDetails
            showModal={showModal}
            setShowModal={setShowModal}
            event={event}
            setShowJobOnboardingModal={setShowJobOnboardingModal}
          />
        )}
        {showEditInterviewModal && (
          <CreateInterviewModal
            showModal={showEditInterviewModal}
            setShowModal={setShowEditInterviewModal}
            interview={event}
          />
        )}
        {showJobOnboardingModal && (
          <AddToJobOnboard
            showModal={showJobOnboardingModal}
            setShowModal={setShowJobOnboardingModal}
            applicationId={event?.application_id}
            interviewId={event?.id}
          />
        )}
        {showCreateInterviewModal && (
          <CreateInterviewModal
            showModal={showCreateInterviewModal}
            setShowModal={setShowCreateInterviewModal}
          />
        )}
      </div>
    </>
  )
}

const InterviewDetails = ({
  showModal,
  setShowModal,
  event,
  setShowJobOnboardingModal,
}) => {
  const dispatch = useDispatch()

  // const [jobStage, setJobStage] = useState(null)
  const [jobStages, setJobStages] = useState([])

  // useEffect(() => {
  //   setJobStage(event?.job_stage)
  // }, [event?.job_stage])

  const interViewStage = jobStages?.find((el) => el?.interview_stage === 'true')

  const hiredStage = jobStages?.find((el) => el?.hired_stage === 'true')

  const [showCreateInterviewModal, setShowCreateInterviewModal] =
    useState(false)

  const [showOnboardingModal, setShowOnboardingModal] = useState(false)

  useEffect(() => {
    AxiosInstance.get(`/recruitment/setup/job_stage`).then((data) =>
      setJobStages(
        data?.map((el) => {
          return {
            name: el?.value,
            id: el?.id,
            interview_stage: el?.interview_stage,
            hired_stage: el?.hired_stage,
          }
        })
      )
    )
  }, [])

  return (
    <>
      <Modal
        isOpen={showModal && !showCreateInterviewModal && !showOnboardingModal}
        toggle={() => setShowModal(false)}
        size='lg'
        centered
        scrollable
      >
        <ModalHeader
          className='border-bottom'
          toggle={() => setShowModal(false)}
        >
          {event?.title}
        </ModalHeader>
        <ModalBody className='scrollbar'>
          <span className='title'>Schedule Detail</span>

          <div
            className='d-flex justify-content-between mt-3 mb-4'
            style={{ fontSize: '13px' }}
          >
            <div
              className='d-flex flex-column font-weight-bold w-50'
              style={{ gap: '0.5rem' }}
            >
              <span>Job</span>
              <span>Interview On</span>
              <span>Assigned Employee</span>
              <span>Meeting Type</span>
              <span>Start Url / Join Url</span>
            </div>
            <div
              className='d-flex flex-column font-weight-bold w-50'
              style={{ gap: '0.5rem' }}
            >
              <span>{event?.title}</span>
              <span>
                {moment(event?.date).format('DD-MM-YYYY')}{' '}
                {formatToAmPm(event?.time)} -{' '}
                {event?.end_time ? formatToAmPm(event?.end_time) : '?'}
              </span>
              <span>
                {event?.with_ai ? 'AI-Conducted Interview' : event?.employee}
              </span>
              <span>-</span>
              <span>{event?.meeting_info}</span>
            </div>
          </div>

          <span className='title'>Candidate Detail</span>

          <div
            className='d-flex justify-content-between mt-3 mb-4'
            style={{ fontSize: '13px' }}
          >
            <div
              className='d-flex flex-column font-weight-bold w-50'
              style={{ gap: '0.5rem' }}
            >
              <span>Name</span>
              <span>Email</span>
              <span>Phone</span>
            </div>
            <div
              className='d-flex flex-column font-weight-bold w-50'
              style={{ gap: '0.5rem' }}
            >
              <span>{event?.applicant_name}</span>
              <span>{event?.applicant_email}</span>
              <span> {event?.applicant_phone}</span>
            </div>
          </div>

          <span className='title'>Candidate Status</span>
          {jobStages?.map((stage) => (
            <div className='custom-control custom-radio mt-3 mr-4'>
              <input
                className='custom-control-input'
                defaultChecked={false}
                id={stage?.id}
                type='radio'
                name='job_stage'
                checked={stage?.id === event?.job_stage}
                onChange={() => {
                  if (
                    event?.job_stage === interViewStage?.id &&
                    stage?.id !== interViewStage?.id
                  ) {
                    dispatch(
                      setAreYouSureModalData({
                        show: true,
                        text: 'All scheduled interviews with this candidate will be removed!',
                        customFn: () =>
                          dispatch(
                            updateJobApplication(event?.application_id, {
                              job_stage: stage?.id,
                            })
                          ),
                      })
                    )
                    return
                  }

                  if (
                    event?.job_stage === hiredStage?.id &&
                    stage?.id !== hiredStage?.id
                  ) {
                    dispatch(
                      setAreYouSureModalData({
                        show: true,
                        text: 'Candidate will be removed from job onboarding',
                        customFn: () =>
                          dispatch(
                            updateJobApplication(event?.application_id, {
                              job_stage: stage?.id,
                            })
                          ),
                      })
                    )
                    return
                  }
                  if (interViewStage) {
                    if (stage?.id === interViewStage?.id) {
                      setShowCreateInterviewModal(true)
                      return
                    }
                  }

                  if (hiredStage) {
                    if (stage?.id === hiredStage?.id) {
                      setShowOnboardingModal(true)
                      return
                    }
                  }
                  dispatch(
                    updateJobApplication(event?.application_id, {
                      job_stage: stage?.id,
                    })
                  )
                }}
              />
              <label className='custom-control-label' htmlFor={stage?.id}>
                {stage?.name}
              </label>
            </div>
          ))}
        </ModalBody>
        <ModalFooter>
          <SubmitModalButton
            customFn={() => {
              setShowJobOnboardingModal(true)
              setShowModal(false)
            }}
            text={'Add to Job OnBoard'}
          ></SubmitModalButton>
        </ModalFooter>
      </Modal>
      {showOnboardingModal && (
        <AddToJobOnboard
          showModal={showOnboardingModal}
          setShowModal={setShowOnboardingModal}
          applicationId={event?.application_id}
          onSuccessFn={() => setShowModal(false)}
        />
      )}
    </>
  )
}

export default InterviewSchedule
